'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var TEST_LOCALSTORAGE_KEY = 'TEST_LOCALSTORAGE_KEY_OPENTICKET';
function hasLocalStorage() {
    try {
        if (typeof localStorage !== 'undefined') {
            localStorage.setItem(TEST_LOCALSTORAGE_KEY, 'yes');
            if (localStorage.getItem(TEST_LOCALSTORAGE_KEY) === 'yes') {
                localStorage.removeItem(TEST_LOCALSTORAGE_KEY);
                return true;
            }
        }
        return false;
    }
    catch (e) {
        return false;
    }
}

exports.default = hasLocalStorage;
//# sourceMappingURL=has_local_storage.js.map
